import { useTranslation } from 'react-i18next';
import { Button, Form, Input, Modal, Typography } from 'antd';
import Icon from 'utils/icon';

import './confirmModal.scss';
import { useState } from 'react';
import NotificationService from 'core/services/notification';

interface ConfirmModalProps {
	open: boolean;
	title: string;
	confirmText: string;
	onDiscard: any;
	onConfirm: any;
	description?: string;
	note?: string;
	isLoading?: boolean;
	confirmType?: 'red' | 'primary';
	inputMessage?: boolean;
	inputLabel?: string;
}

function ConfirmModalComponent({
	open,
	title,
	confirmText,
	onDiscard,
	onConfirm,
	description,
	note,
	isLoading,
	confirmType = 'red',
	inputMessage,
	inputLabel,
}: ConfirmModalProps) {
	const { t } = useTranslation();
	const [form] = Form.useForm();

	const handleConfirm = async () => {
		try {
			if (inputMessage) {
				const formValues = await form.validateFields(['message']);
				onConfirm(formValues.message);
			} else onConfirm();
		} catch (error: any) {
			if (error?.errorFields) return; // skip form validation errors
		}
	};

	return (
		<>
			<Modal
				open={open}
				title={title}
				className="confirmationModal"
				onCancel={onDiscard}
				footer={[
					<Button key="discard" className="discard" onClick={onDiscard}>
						{t('COMMON.DISCARD')}
					</Button>,
					<Button key="confirm" variant="solid" color={confirmType} onClick={handleConfirm} loading={isLoading}>
						{confirmText}
					</Button>,
				]}>
				{description && <p className="mb-0">{description}</p>}

				{inputMessage && (
					<div className="my-3">
						<Form form={form}>
							<Typography.Text className="mb-1 d-block">{inputLabel ?? t('COMMON.REJECT_REASON')}</Typography.Text>
							<Form.Item
								name="message"
								rules={[
									{ required: true, message: t('COMMON.REJECT_REASON_REQUIRED') },
									{ min: 4, max: 200, message: t('COMMON.REJECT_REASON_LENGTH') },
								]}
								style={{ maxWidth: '100%' }}>
								<Input.TextArea autoSize={{ minRows: 3, maxRows: 5 }} />
							</Form.Item>
						</Form>
					</div>
				)}

				{note && (
					<div className="highlight mt-2">
						<Icon name="flag" width={35} height={35} style={{ minWidth: '35px' }} />
						<span>{note}</span>
					</div>
				)}
			</Modal>
		</>
	);
}

export default ConfirmModalComponent;
